'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var singleton = exports.singleton = Symbol.for('us_instance');
var singletonEnforcer = Symbol.for('enforcing');

var UtilityService = function () {
	function UtilityService(enforcer) {
		_classCallCheck(this, UtilityService);

		if (enforcer !== singletonEnforcer) {
			throw new Error('Cannot construct a singleton');
		}
	}

	_createClass(UtilityService, [{
		key: 'getBase64Length',
		value: function getBase64Length(str) {
			return 4 * Math.ceil(parseFloat(str.length / 3));
		}
	}, {
		key: 'generateGUID',
		value: function generateGUID() {
			var d = new Date().getTime();
			var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = (d + Math.random() * 16) % 16 | 0;
				d = Math.floor(d / 16);
				return (c == 'x' ? r : r & 0x7 | 0x8).toString(16);
			});
			return uuid;
		}
	}, {
		key: 'checkIsIPV4',
		value: function checkIsIPV4(entry) {
			if (/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(entry)) {
				return true;
			} else {
				return false;
			}
		}
	}, {
		key: 'getPageLoadData',
		value: function getPageLoadData() {
			var _d = {};
			_d.ua = navigator.userAgent;
			_d.av = navigator.appVersion;
			_d.an = navigator.appName;
			_d.pl = navigator.platform;
			_d.lg = navigator.userLanguage == null ? navigator.language == null ? '' : navigator.language : navigator.userLanguage;
			_d.je = navigator.javaEnabled();
			_d.sw = screen.width;
			_d.sh = screen.height;
			_d.cd = screen.colorDepth;
			_d.ref = encodeURIComponent(document.referrer);
			_d.url = encodeURIComponent(document.URL);
			_d.T = 'pl';
			//_d.acc = "MediaPlatform";
			_d.iip = global.user_ip || "";

			//TODO grab user ID from redux store in common
			//_d.userid = this.generateGUID();
			//_d.cv = MP.DataCollector.getInstance().getVersion();

			return _d;
		}

		/**
  * Utility function to extrapolate specific stream information based on stream URL
  *
  * @param {String} playerURL
  *        current player src
  * 
  * @param {Player} playerObj 
  *        optional videojs player object
  * 
  */

	}, {
		key: 'getStreamInfo',
		value: function getStreamInfo(playerURL, playerObj) {
			//TODO: Wicked cleanup needed with this function
			//We are going to have 3 data points of interest here. Format, Distribution and Protocol.
			// Format(sf)
			// 	hls
			// 	mp4 (VOD only)

			// Distribution(sd)
			// https unicast

			// Protocol(sp)
			// 	https

			if (playerURL === undefined) {
				return null;
			}

			var curStream = void 0,
			    mi = void 0,
			    purl = void 0;

			if (playerObj !== undefined) {
				mi = JSON.parse(playerObj.getDebugInfo());
				curStream = mi.submittedURL;
			} else {
				curStream = playerURL;
			}

			//Lets strip the query params off of the url
			var obj = { sabr: false, surl: curStream.split("?")[0] };

			//We are going to check for properietary implementations first - rtmphost~
			if (curStream.indexOf('rtmphost') !== -1) //ABR, Format:flash, Distribution:adobe unicast
				{
					var arr = curStream.split(',');
					var host = arr[0].split('~')[1];
					var streamsArr = [];
					for (var key in arr) {
						if (arr[key].indexOf('rtmphost') === -1) {
							streamsArr.push({ br: arr[key].split('~')[1], stream: arr[key].split('~')[0] });
						}
					}
					obj.sf = 'flash';
					obj.sd = 'adobe unicast';
					obj.sp = 'rtmp';
					obj.sabr = true;
					obj.sh = host;
					obj.sts = streamsArr;
					obj.surl = playerURL;

					return obj;
				} else {
				//let's run the url through the parse function
				purl = this.parseURL(curStream);
				obj.sp = purl.protocol;
				obj.sh = purl.host;
			}

			//Let's take care of the edge cases next
			//RAMP
			if (purl.pathname.indexOf('~~/master') !== -1) {
				obj.sd = 'ramp';
				obj.sh = purl.hostname;
				obj.shp = purl.port;
				obj.sp = purl.protocol;
			}
			//Kollective
			//Kollective rtmp will not have a host
			else if (purl.pathname.indexOf('urn:kid:') !== -1) {
					obj.sd = 'kollective';
					obj.sh = purl.hostname;
					obj.shp = purl.port;
					obj.sp = purl.protocol;

					obj.sp.indexOf('rtmp') !== -1 ? obj.sf = 'kollective_rtmp' : obj.sf = undefined;
				}

				//HIVE
				else if (purl.host.indexOf(':8999') !== -1) {
						obj.sd = 'hive p2p';
						obj.sh = purl.hostname;
						obj.shp = purl.port;
						obj.sp = purl.protocol;
					}
					//Zixi
					else if (purl.hostname.indexOf('zixi') !== -1) {
							obj.sd = 'zixi';
							obj.sh = purl.hostname;
							obj.shp = purl.port;
							obj.sp = purl.protocol;
						}
						//Peer5
						else if (global.hasOwnProperty("peer5") && global.peer5 !== undefined) {
								if (global.peer5.isEnabled() === true) {
									obj.sd = 'WebRTC p2p';
									obj.sh = purl.hostname;
									obj.shp = purl.port;
									obj.sp = purl.protocol;
								}
							} else {
								if (curStream.indexOf('rtmp') !== -1) //Format:flash, Distribution:adobe unicast
									{
										obj.sd = 'adobe unicast';
										obj.sf = 'flash';
										obj.sh = purl.hostname;
									}
							}

			if (curStream.indexOf('rtmfp') !== -1) //Format:flash, Distribution:adobe fusion/multicast/p2p
				{
					obj.ma = purl.searchObject.address || '';
					obj.sn = purl.searchObject.streamname || '';
					//need to check multicast type

					if (purl.searchObject.type === '1') //Fusion
						{
							obj.sd = 'adobe fusion';
						} else if (purl.searchObject.type === '2') //IP Multicast
						{
							obj.sd = 'adobe multicast';
						} else if (purl.searchObject.type === '3') //P2P
						{
							obj.sd = 'adobe p2p';
						}
					obj.sf = 'flash';
				}
			if (mi !== undefined) {
				//Format:flash, Distribution:adobe multicast (connectionless)
				if (mi.mediaURL === 'rtmfp:') {
					obj.sd = 'adobe multicast';
					obj.sf = 'flash';
				}
			}

			// if(purl.protocol === 'http' || purl.protocol === 'https')//HTTP
			// {
			// 	obj.sh = purl.host;
			//
			// }

			switch (purl.extension) {
				case 'f4m':
					obj.sf === undefined || obj.sf === null ? obj.sf = 'hds' : obj.sf;
					obj.sd === undefined || obj.sd === null ? obj.sd = obj.sp + ' unicast' : obj.sd;
					break;
				case 'flv':
				case 'f4v':
					if (purl.protocol === 'http' || purl.protocol === 'https') {
						obj.sf = 'progressive';
					} else {
						obj.sf = 'flash';
					}
					break;
				case 'm3u8':
					obj.sf === undefined || obj.sf === null ? obj.sf = 'hls' : obj.sf;
					obj.sd === undefined || obj.sd === null ? obj.sd = obj.sp + ' unicast' : obj.sd;
					break;
				case 'mp4':
					obj.sf = 'mp4';
					break;
				default:

					break;
			}
			return obj;
		}
		//utility function to get extension

	}, {
		key: 'getExtension',
		value: function getExtension(url) {
			// Extension starts after the first dot after the last slash
			var extStart = url.indexOf('.', url.lastIndexOf('/') + 1);
			if (extStart == -1) return "";
			var ext = url.substr(extStart + 1),

			// end of extension must be one of: end-of-string or question-mark or hash-mark
			extEnd = ext.search(/$|[?#]/);
			return ext.substring(0, extEnd);
		}
		//utility function to parse a URL with http protocol.

	}, {
		key: 'parseURL',
		value: function parseURL(url) {
			var parser = document.createElement('a'),
			    searchObject = {},
			    queries,
			    split,
			    i;

			//We're going to force the protocol to http just for the parsing.
			var splitURL = url.split("://");
			var originalProtocol = splitURL[0];
			var newURL = "http://" + splitURL[1];
			// Let the browser do the work
			parser.href = newURL;
			//var ext = url.substring(url.lastIndexOf('.')+1).toLowerCase();
			var ext = this.getExtension(url);

			// Convert query string to object
			queries = parser.search.replace(/^\?/, '').split('&');
			for (i = 0; i < queries.length; i++) {
				split = queries[i].split('=');
				searchObject[split[0]] = split[1];
			}
			return {
				//protocol: parser.protocol.replace(':', ''),
				protocol: originalProtocol,
				host: parser.host,
				hostname: parser.hostname,
				port: parser.port,
				pathname: parser.pathname,
				search: parser.search,
				searchObject: searchObject,
				hash: parser.hash,
				extension: ext
			};
		}
	}], [{
		key: 'us_instance',
		get: function get() {
			if (!UtilityService[singleton]) {
				UtilityService[singleton] = new UtilityService(singletonEnforcer);
			}

			return UtilityService[singleton];
		}
	}]);

	return UtilityService;
}();

exports.default = UtilityService;